module.exports = __webpack_public_path__ + "img/alex_logo.fd15ae39.png";